export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: '51爆料的内容可信吗？你们如何核实投稿？',
    a: '我们采用「分级核实」机制：每位投稿人需提交可匿名化的佐证（邮件截图、工牌打码、OA 页面等），编辑据此判定为「已核实」「待核实」或「持续更新」。标注「待核实」的内容会保留，直到收到书面证据或更多同源投稿才会升级，未核实的传闻我们会明确提示读者理性看待。',
  },
  {
    q: '我想爆料，如何保证自己的隐私安全？',
    a: '你可以通过页面底部的匿名投稿邮箱提交，全程不要求提供真实姓名、手机号或公司账号。编辑只在沟通澄清时联系你，且支持一次性邮箱。我们承诺不主动公开投稿人任何可识别身份的信息，涉及真实身份的内容一律打码处理。',
  },
  {
    q: '投稿会先经被提及的公司或个人确认吗？',
    a: '对于涉及具体公司与高管的重大爆料，我们会在发布前向相关方提供「陈述与回应」机会，并在文中如实呈现对方的公开回应或「未回应」状态。这是为了平衡多方立场、减少误伤，也符合负责任报道的基本要求。',
  },
  {
    q: '如果报道侵犯了我的隐私或名誉，怎么办？',
    a: '我们设有专门的勘误与投诉通道。如果你认为某条内容存在事实错误、泄露个人隐私或构成不实指控，请通过联系我们页面的邮箱说明问题并附上相关说明，我们会在核实后及时修正、删除或作出更正声明。',
  },
  {
    q: '51爆料会不会为了流量偏袒某一方、故意带节奏？',
    a: '不会。我们的价值在于降低信息不对称，而不是制造对立。编辑部有一条底线：可陈述事实、可呈现多方视角，但绝不无据攻击任何个人或企业。所有带强烈负面结论的内容，都要求至少两位投稿人或书面佐证相互印证。',
  },
  {
    q: '爆料会获得报酬吗？',
    a: '我们目前不对提供公开爆料信息支付报酬，以避免诱导夸张或编造。但对线索质量高、帮助推动重要调查的投稿人，我们会提供深度内容的署名权或知识产品以示认可。感谢每一位愿意分享真实情况的人。',
  },
  {
    q: '我可以在公司内部讨论里引用 51爆料的内容吗？',
    a: '可以，但建议谨慎。平台内容仅代表投稿人与编辑部基于现有信息的判断，不构成法律或事实结论。引用时请保留核实状态标注，避免把「待核实」的内容当作定论传播，以免造成二次误伤。',
  },
  {
    q: '你们与求职平台、猎头或企业有合作关系吗？',
    a: '我们是独立运营的职场信息社区，不隶属于任何猎头、求职平台或企业。接受公开的媒体合作与转载授权，但任何涉及利益相关的内容都会明确标注「商业合作」，以保障读者判断的独立性。',
  },
];